import { GetEndDateForStartUpAgreement } from "@portal/helpers";
import { ICreateSavingsAgreement } from "@portal/types/api/ICreateSavingsAgreement";
import { IModifySavingsAgreement } from "@portal/types/api/IModifySavingsAgreement";
import { IModifySavingsAgreementFund } from "@portal/types/api/IModifySavingsAgreementFund";
import { ISavingAgreementData } from "@portal/types/robot/ISavingAgreementData";
import { addDays, format } from "date-fns";

/**
 * Component to create a start-up agreement.
 * @param agreementRequest
 * @param requestAgreementData
 * @returns a savings agreement or null.
 */
export const GetStartUpAgreementRequest = (
  agreementRequest: ICreateSavingsAgreement,
  requestAgreementData: ISavingAgreementData,
) => {
  if (requestAgreementData.oneTimeDeposit === 0) return null;

  const inFiveDays = addDays(new Date(), 5);

  const agreementData = {
    adjustmentComment: "Oppstartsavtale",
    advisorCarriedOut: agreementRequest.agreementData.advisorCarriedOut,
    advisorName: agreementRequest.agreementData.advisorName,
    cashAccount: agreementRequest.agreementData.otherCashAccount
      ? agreementRequest.agreementData.otherCashAccount
      : agreementRequest.agreementData.cashAccount,
    dateFrom: agreementRequest.agreementData.dateFrom,
    dateTo: GetEndDateForStartUpAgreement(requestAgreementData.numOfMonthsStartupAmount),
    nextDate: format(inFiveDays, "yyyy-MM-dd"),
    monthTable: agreementRequest.agreementData.monthTable,
    periodDayNumber: inFiveDays.getDate(),
    periodType: agreementRequest.agreementData.periodType,
    savingsAgreementDescription: agreementRequest.agreementData.savingsAgreementDescription,
    funds: MapFundsToStartUpAgreement(
      agreementRequest.agreementData.funds,
      requestAgreementData.oneTimeDeposit,
      requestAgreementData.numOfMonthsStartupAmount,
    ),
    isSavingRobot: true,
  } as IModifySavingsAgreement;

  return { portfolioId: agreementRequest.portfolioId, agreementData } as ICreateSavingsAgreement;
};

export const MapFundsToStartUpAgreement = (funds: IModifySavingsAgreementFund[], oneTimeDeposit: number, months: number) => {
  const fundsForStartUpAgreement = [] as IModifySavingsAgreementFund[];

  funds.forEach(fund => {
    fundsForStartUpAgreement.push({
      isin: fund.isin,
      amount: CalculateStartUpAmountForFund(oneTimeDeposit, months, fund),
      name: fund.name,
    } as IModifySavingsAgreementFund);
  });

  return fundsForStartUpAgreement;
};

export const CalculateStartUpAmountForFund = (oneTimeDeposit: number, months: number, fund: IModifySavingsAgreementFund) => {
  return (oneTimeDeposit * fund.percentage) / 100 / months;
};
